export default "__VITE_ASSET__pfOKgPRy__"